import { useEffect, useState } from 'react';
import './Event.css';
import { useParams } from 'react-router-dom';
import { getEventByIdAndDate } from '../../http/eventAPI';
import ClassicButton from '../../components/UI/ClassicButton/ClassicButton';
import { IEventPageResponseModel } from '../../interfaces/responses/IEventPageResponseModel';
import EventTicket from '../../components/EventTicket/EventTicket';
import BookingModal from '../../components/BookingModal/BookingModal';
import useScreenWidth from '../../hooks/useScreenWidth';

const Event: React.FC = () => {
    const { eventId, dateId } = useParams();
    const [eventInfo, setEventInfo] = useState<IEventPageResponseModel>();
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [alertVisible, setAlertVisible] = useState<boolean>(false);
    const [alertMessage, setAlertMessage] = useState<string>('');
    const [isVisible, setVisible] = useState<boolean>(false);
    const screenWidth = useScreenWidth();

    useEffect(() => {
        setVisible(true);
    }, []);
    
    const handleBooking = () => {
        setModalVisible(!modalVisible);
    }
    
    const handleCloseModal = () => {
        setModalVisible(false);
    }
    
    const handlePaymentSuccess = () => {
        setAlertMessage('Оплата прошла успешно! Проверьте электронную почту.');
        setAlertVisible(true);
    };
    
    useEffect(() => {
        if (eventId) {
            getEventByIdAndDate(eventId, dateId)
                .then((responce) => {
                    if (typeof responce === 'object' && !Array.isArray(responce)) {
                        setEventInfo(responce);
                    } else {
                        console.log('Неправильный формат ответа', responce);
                    }
                })
                .catch(() => {
                    console.log('Ошибка при получении информации о событии.');
                });
        }
    }, [eventId, dateId]);
    
    return (
        <>
            <div className={`event ${isVisible ? 'visible' : ''}`}>
                <div className='event_header' style={{ backgroundImage: `url(https://minio.greenspacegg.ru:9000/meart/${eventInfo?.image})` }}>
                    <h3>{eventInfo?.title}</h3>
                    {screenWidth > 1024 && (
                        <div className='event_header_button'>
                            <ClassicButton
                                bgColor='#ffe5cc'
                                fontColor='#8e0606'
                                padding='5px'
                                width='150px'
                                fontFamily='Actay Regular'
                                fontSize='18px'
                                onClick={handleBooking}
                            >Купить билет</ClassicButton>
                        </div>
                    )}
                </div>
                
                <h3>Билет</h3>
                <div className='event_tickets'>
                    {screenWidth > 1024 ? (
                        <>
                            {eventInfo?.ticketTypes.slice(0, 1).map((t, idx) => (
                                <EventTicket
                                    key={idx}
                                    event={eventInfo}
                                    ticketType={t.type}
                                    ticketPrice={t.price}
                                />
                            ))}
                        </>
                    ) : (
                        <ClassicButton
                            bgColor='#ffe5cc'
                            fontColor='#8e0606'
                            padding='5px'
                            width='150px'
                            fontFamily='Actay Regular'
                            fontSize='18px'
                            onClick={handleBooking}
                        >Купить билет</ClassicButton>
                    )}
                </div>
                
                <h3>О событии</h3>
                <div className='event_description'>
                    {eventInfo?.description}
                </div>
            </div>
            
            {eventInfo && (
                <BookingModal 
                    event={eventInfo} 
                    мodalVisible={modalVisible} 
                    setModalVisible={setModalVisible} 
                    onCloseModal={handleCloseModal}
                    onPaymentSuccess={handlePaymentSuccess}
                />
            )}
        </>
    );
};

export default Event;